import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=4627a550&scoped=true"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=4627a550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627a550",
  null
  
)

export default component.exports